import { Typography } from "@mui/material";


export function Error() {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "20rem",
          gap: "20px",
        }}
      >
        <Typography sx={{ fontSize: "40px", fontWeight: "bold" }}>
          Page Not Found
        </Typography>
      </div>
    </>
  );
}
